import { render, staticRenderFns } from "./Actualites.vue?vue&type=template&id=4042bec8&"
import script from "./Actualites.vue?vue&type=script&lang=js&"
export * from "./Actualites.vue?vue&type=script&lang=js&"
import style0 from "./Actualites.vue?vue&type=style&index=0&id=4042bec8&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports